var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c(_vm.icon,{ref:"svg",tag:"component",class:_vm.classes,on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }